export const castToType = <T>(value: string | null) => {
    if (value) {
        if (!isNaN(parseInt(value))) {
            return parseInt(value) as T;
        }

        return value as T;
    }
};

export const castToTypeArray = <T>(value?: string[] | null) =>
    Array.isArray(value)
        ? (value.map(castToType).filter((v) => v !== undefined) as T[])
        : [];
